import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { getAssignmentQuery, GetAssignmentQueryResult, GetAssignmentQueryVariables } from '../graphql/queries/getAssignmentQuery';
import { Assignment } from '../types';

interface AssignmentHookInput {
  courseId: string;
  assignmentId: string;
}

interface AssignmentHookOutput {
  assignment?: Assignment;
  loading: boolean;
}

export default function useAssignment(input: AssignmentHookInput): AssignmentHookOutput {
  const { courseId, assignmentId } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetAssignmentQueryResult, GetAssignmentQueryVariables>(getAssignmentQuery, {
    variables: { courseId, assignmentId },
    fetchPolicy: 'network-only',
    onError: showErrorNotification,
  });

  return {
    assignment: data?.assignment,
    loading,
  };
}
